import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6fefdc7dc7fdacf5deaf0a7aa6e9f19b.jpg"
          alt="Earth Wisdom boutique fashion"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/65"></div>
      </div>

      {/* Free Shipping Badge */}
      <div
        className="absolute top-28 right-6 md:right-12 z-10 w-24 h-24 md:w-28 md:h-28 rounded-full flex flex-col items-center justify-center text-center border-2 border-[#E8B96A]"
        style={{ backgroundColor: 'rgba(201,147,58,0.92)' }}
      >
        <span style={{ fontFamily: '"Lato", sans-serif', color: '#fff', fontSize: '0.6rem', fontWeight: 700, letterSpacing: '0.05em', lineHeight: 1.2 }}>FREE</span>
        <span style={{ fontFamily: '"Lato", sans-serif', color: '#fff', fontSize: '0.6rem', fontWeight: 700, letterSpacing: '0.05em', lineHeight: 1.2 }}>SHIPPING</span>
        <span style={{ fontFamily: '"Playfair Display", serif', color: '#fff', fontSize: '1rem', fontWeight: 900, lineHeight: 1.2 }}>$75+</span>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 w-full text-center px-4 md:px-8 max-w-5xl mx-auto pt-20">
        <p
          style={{ fontFamily: '"Dancing Script", cursive', color: '#E8B96A', fontSize: '1.4rem' }}
          className="mb-4 animate-fade-in"
        >
          Michigan&apos;s most magical boutique since 1981
        </p>

        <h1
          style={{ fontFamily: '"Playfair Display", serif', color: '#FFFFFF', lineHeight: 1.1 }}
          className="text-5xl md:text-7xl font-black mb-2"
        >
          OUTRAGEOUSLY
        </h1>
        <h2
          style={{ fontFamily: '"Playfair Display", serif', color: '#E8B96A', lineHeight: 1.1 }}
          className="text-4xl md:text-6xl font-bold italic mb-2"
        >
          Gorgeous &amp; Hilarious
        </h2>
        <h3
          style={{ fontFamily: '"Playfair Display", serif', color: '#FAF7F2', lineHeight: 1.2 }}
          className="text-2xl md:text-3xl font-normal mb-8"
        >
          Fashion for Every Body, Every Vibe
        </h3>

        <p
          style={{ fontFamily: '"Lato", sans-serif', color: '#EDE5D8', lineHeight: 1.8, maxWidth: '640px' }}
          className="text-base md:text-lg mx-auto mb-10"
        >
          Goddess clothing that makes you feel like royalty. Artist-designed tees that make you snort-laugh.
          The legendary Magic Dress. Healing music. All in one place — affordable, unique, and absolutely you.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/contact"
            className="px-8 py-4 rounded-lg font-bold text-base uppercase tracking-wide whitespace-nowrap transition-all duration-200 hover:-translate-y-0.5"
            style={{ backgroundColor: '#C9933A', color: '#fff', fontFamily: '"Lato", sans-serif', letterSpacing: '0.1em' }}
          >
            Shop Now
          </Link>
          <a
            href="#magic-dress"
            className="px-8 py-4 rounded-lg font-bold text-base uppercase tracking-wide whitespace-nowrap transition-all duration-200 hover:-translate-y-0.5 border-2"
            style={{ borderColor: '#E8B96A', color: '#E8B96A', fontFamily: '"Lato", sans-serif', letterSpacing: '0.1em', backgroundColor: 'transparent' }}
          >
            See the Magic Dress
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span style={{ fontFamily: '"Lato", sans-serif', color: '#E8B96A', fontSize: '0.7rem', letterSpacing: '0.15em' }}>EXPLORE</span>
        <i className="ri-arrow-down-line text-[#E8B96A] text-xl animate-bounce"></i>
      </div>
    </section>
  );
}
